import { ApolloClient } from "@apollo/client";
import { GetProductCategoriesDocument } from "@me-team/host/main/products/graphql/products.hooks";

export const refreshProductCategoriesCache = (client: ApolloClient<object>, branchId: string | number) => {
    return client.query({
        query: GetProductCategoriesDocument,
        variables: {
            itemsPerPage: 1000,
            branchId: Number(branchId),
        },
        fetchPolicy: "network-only",
    });
};
